"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (collection) { return function (subject) {
    return collection.indexOf(subject) !== -1;
}; });
